import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconNook32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconNook32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M29 21.619a2 2 0 0 0-.89-1.665l-3.263-2.175v-3.03A2 2 0 0 0 23.818 13l-3.125-1.736V7.791a2 2 0 0 0-.94-1.696L16.53 4.081 16 3.75l-.53.331-3.222 2.014a2 2 0 0 0-.94 1.696v3.473L8.183 13a2 2 0 0 0-1.029 1.749v3.03l-3.263 2.175A2 2 0 0 0 3 21.62v4.207l.5.279.025.013 3.681 2.045a2 2 0 0 0 1.866.04l2.799-1.399 3.316 1.474a2 2 0 0 0 1.625 0l3.316-1.474 2.799 1.4a2 2 0 0 0 1.865-.04l3.683-2.047.022-.012.503-.28V21.62m-2 1.944V21.62l-3.263-2.176a2 2 0 0 1-.89-1.664v-3.03l-3.126-1.737a2 2 0 0 1-1.028-1.748V7.791L17 6.734v11.445zm-1.083 1.688L16 19.911l-9.916 5.34 2.095 1.164 2.798-1.4a2 2 0 0 1 1.707-.038L16 26.45l3.317-1.474a2 2 0 0 1 1.707.039l2.798 1.399zM5 23.563l10-5.385V6.733l-1.692 1.058v3.473a2 2 0 0 1-1.029 1.748L9.154 14.75v3.03a2 2 0 0 1-.89 1.664L5 21.62z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconNook32);
